import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";

const {ccclass, property} = cc._decorator;

enum guessType{
    stone,
    scissors,
    cloth
}

@ccclass
export default class guessFistPage extends cc.Component {

    @property({type:cc.SpriteFrame,displayName:"石头剪刀布的图片"})
    sps:cc.SpriteFrame[] = [];

    @property({type:cc.Node,displayName:"开始选择节点"})
    startSelectLayout:cc.Node = null;

    @property({type:cc.Sprite,displayName:"自己出拳的图片"})
    meGuessSp:cc.Sprite = null;

    @property({type:cc.Sprite,displayName:"ai出拳的图片"})
    aiGuessSp:cc.Sprite = null;

    @property({type:cc.Label,displayName:"中心显示的文本"})
    centerLb:cc.Label = null;

    @property({type:cc.Node,displayName:"自己出拳的节点"})
    meGuessNode:cc.Node = null;

    @property({type:cc.Node,displayName:"ai出拳的节点"})
    aiGuessNode:cc.Node = null;

    meGuessType:guessType = null;

    /**
     * winFlag 0 是胜利 1是平局 2 是失败
     */
    completeFun:(winFlag:number)=>void = null;

    bindCompleteFun(completeFun:(winFlag:number)=>void){
        this.completeFun = completeFun;
    }

    start(){
        this.startSelect();
    }

    /**
     * 选择出拳类型
     * @param e touchEvent
     * @param custom 选择的类型
     */
    onBtnSelectItem(e:cc.Event.EventTouch,custom:string){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.meGuessType != null){
            O1HD.getModules().uiControlModule.showMessageBox("已经出过拳了，请等待对方出拳");
            return;
        }
        this.meGuessType = Number(custom);
        this.closeSelect();
        this.checkAISelectType();
        this.startCleanAni();
    }

    canSelect:boolean = true;

    startSelect(){
        let needTime:number = .5;
        cc.tween(this.startSelectLayout).by(needTime,{y:this.startSelectLayout.height}).start();
    }

    closeSelect(){
        let needTime:number = .5;
        cc.tween(this.startSelectLayout).by(needTime,{y:-this.startSelectLayout.height}).start();
    }
    /**
     * 胜利失败的权重 分别对应为 胜利 失败 平局
     */
    winOrFailWeightAry:number[] = [60,20,20];

    winFlag:number = 0;

    aiGuessType:guessType = null;

    checkAISelectType(){
        this.winFlag = data_control.getRandIPosByWeights(this.winOrFailWeightAry);
        this.updateAiGuessByFlag();
    }

    /**
     * 更新AI的出拳类型
     */
    updateAiGuessByFlag(){
        let meGuessType = this.meGuessType;
        switch(this.winFlag){
            case 0:{
                if(meGuessType == guessType.stone){
                    this.aiGuessType = guessType.scissors;
                }else if(meGuessType == guessType.scissors){
                    this.aiGuessType = guessType.cloth;
                }else{
                    this.aiGuessType = guessType.stone;
                }
                break;
            }
            case 1:{
                if(meGuessType == guessType.stone){
                    this.aiGuessType = guessType.cloth;
                }else if(meGuessType == guessType.scissors){
                    this.aiGuessType = guessType.stone;
                }else{
                    this.aiGuessType = guessType.scissors;
                }
                break;
            }
            case 2:{
                this.aiGuessType = meGuessType;
                break;
            }
        }
    }

    /**
     * 更新出拳的图片
     */
    updateGuessSp(){
        let oneSprite = this.getOneSpByGuessType(this.meGuessType);
        let twoSprite = this.getOneSpByGuessType(this.aiGuessType);

        this.meGuessSp.spriteFrame = oneSprite;
        this.aiGuessSp.spriteFrame = twoSprite;
    }

    /**
     * 通过出拳类型获取一张图片
     * @param type 
     * @returns 出拳的显示图片
     */
    getOneSpByGuessType(type:guessType){
        return this.sps[type];
    }

    /**
     * 开始结算动画
     */
    async startCleanAni(){
        this.updateGuessSp();
        await this.centerLbAni();
        await this.guessAni();
        this.showWinDialog();
    }

    centerLbAni(){
        return new Promise<void>(async resolve=>{
            let count = 4;
            for(let i =0;i<count;i++){
                for(let j = 0;j<3;j++){
                    let str = this.getOneTypeStr(j);
                    this.centerLb.string = str;
                    await new Promise<void>(resolve=>{
                        this.scheduleOnce(resolve,0.2);
                    });
                }
            }
            this.centerLb.string = "";
            resolve();
        });
    }

    guessAni(){
        let needTime:number = 1;
        cc.tween(this.meGuessNode).by(needTime,{y:this.meGuessNode.height - 200}).start();
        cc.tween(this.aiGuessNode).by(needTime,{y:-(this.meGuessNode.height - 200)}).start();
        return new Promise<void>(resolve=>{
            this.scheduleOnce(resolve,needTime);
        });
    }

    getOneTypeStr(type:guessType){
        switch(type){
            case guessType.stone:{
                return "石头";
            }
            case guessType.scissors:{
                return "剪刀";
            }
            case guessType.cloth:{
                return "布";
            }
        }
    }

    @property({type:cc.Node,displayName:"winDialog"})
    winDialog:cc.Node = null;

    @property({type:cc.Label,displayName:"胜利dialog文本"})
    winDialogLb:cc.Label = null;

    showWinDialog(){
        let resultLb:string = "";
        switch(this.winFlag){
            case 0:{
                resultLb = "卖家";
                break;
            }
            case 1:{
                resultLb = "买家";
                break;
            }
            case 2:{
                resultLb = "平局";
                break;
            }
        }
        this.winDialog.active = true;
        this.winDialog.scale = 0;
        cc.tween(this.winDialog).to(0.5,{scale:1},{easing:cc.easing.backOut}).start();
        this.winDialogLb.string = resultLb;
        this.scheduleOnce(this.closeThis,2);
    }

    closeThis(){
        this.completeFun && this.completeFun(this.winFlag);
        this.node.destroy();
        this.node.removeFromParent();
    }

}
